module.exports = __webpack_public_path__ + "static/first-243f65add253836bdff2140a8bdc7145.jpg";